import React, { useEffect, useState } from 'react';
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, CircularProgress, Snackbar, Alert, Box, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import axios from 'axios';

export default function GitPanel() {
  const [repos, setRepos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, msg: '', severity: 'success' });
  const [confirm, setConfirm] = useState({ open: false, key: '', action: '' });

  const fetchStatus = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get('/api/git/status');
      setRepos(data);
    } catch {
      setSnackbar({ open: true, msg: 'Failed to fetch git status', severity: 'error' });
    }
    setLoading(false);
  };

  useEffect(() => { fetchStatus(); }, []);

  const handleAction = (action, key) => {
    setConfirm({ open: true, key, action });
  };

  const confirmAction = async () => {
    setLoading(true);
    setConfirm({ open: false, key: '', action: '' });
    try {
      const { data } = await axios.post(`/api/git/${confirm.key}/${confirm.action}`);
      setSnackbar({ open: true, msg: `${confirm.action === 'pull' ? 'Rebuilt' : 'Rolled back'} ${confirm.key}`, severity: 'success' });
      fetchStatus();
    } catch {
      setSnackbar({ open: true, msg: `Failed to ${confirm.action} ${confirm.key}`, severity: 'error' });
    }
    setLoading(false);
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>Git Status & Rebuild</Typography>
      {loading ? <CircularProgress sx={{ mt: 2 }} /> :
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Service</TableCell>
                <TableCell>Branch</TableCell>
                <TableCell>Latest Commit</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {repos.map(repo => (
                <TableRow key={repo.key}>
                  <TableCell>{repo.name}</TableCell>
                  <TableCell>{repo.branch || '-'}</TableCell>
                  <TableCell><Box sx={{ maxWidth: 300, whiteSpace: 'pre-line' }}>{repo.commit || '-'}</Box></TableCell>
                  <TableCell>{repo.status || (repo.error ? <Alert severity="error">{repo.error}</Alert> : '-')}</TableCell>
                  <TableCell>
                    <Button size="small" onClick={() => handleAction('pull', repo.key)} disabled={loading || repo.error}>Rebuild</Button>
                    <Button size="small" color="warning" onClick={() => handleAction('rollback', repo.key)} disabled={loading || repo.error}>Rollback</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      }
      <Dialog open={confirm.open} onClose={() => setConfirm({ open: false, key: '', action: '' })}>
        <DialogTitle>Confirm {confirm.action === 'pull' ? 'Rebuild' : 'Rollback'}</DialogTitle>
        <DialogContent>
          Are you sure you want to {confirm.action === 'pull' ? 'rebuild (git pull)' : 'rollback (reset --hard HEAD~1)'} <b>{confirm.key}</b>?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirm({ open: false, key: '', action: '' })}>Cancel</Button>
          <Button onClick={confirmAction} color={confirm.action === 'pull' ? 'primary' : 'warning'}>Yes</Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity}>{snackbar.msg}</Alert>
      </Snackbar>
    </Box>
  );
}
